import React, { useEffect, forwardRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { getPanelPosition } from './utils/helper';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import floatingPanelStyles from '@dtsl/css-floating-panel/dist/index.module.css';
const FloatingPanel = /*#__PURE__*/forwardRef(function FloatingPanel(props, ref) {
  const {
    isMobile
  } = useIsMobile(640);
  const [position, setPosition] = useState({});
  const [isPanelReady, setIsPanelReady] = useState(false);
  const {
    isVisible,
    setIsVisible,
    children,
    triggerRef,
    style = {},
    className = ''
  } = props;
  const actionListBodyClasses = classNames({
    [floatingPanelStyles['sib-floating-panel']]: true,
    [floatingPanelStyles['sib-floating-panel__body']]: true,
    [floatingPanelStyles['sib-floating-panel__isVisible']]: isPanelReady,
    [floatingPanelStyles['sib-floating-panel__isHidden']]: !isPanelReady,
    [floatingPanelStyles['sib-floating-panel__visible_animation']]: isVisible,
    [floatingPanelStyles['sib-floating-panel__hidden_animation']]: !isVisible
  });
  const backdropClasses = classNames({
    [floatingPanelStyles['sib-floating-panel__backdrop']]: isVisible,
    [floatingPanelStyles['sib-floating-panel__backdrop_visible_animation']]: isVisible,
    [floatingPanelStyles['sib-floating-panel__backdrop_hidden_animation']]: !isVisible,
    [floatingPanelStyles['sib-floating-panel__backdrop_mobile']]: isMobile
  });
  const nestedClasses = classNames({
    //styles to add if needed for children panel
  });
  const handleTopBottomPosition = (trigger, panel) => {
    const newPosition = getPanelPosition(trigger, panel, isMobile);
    isMobile ? setPosition({
      ...newPosition
    }) : setPosition({
      ...position,
      ...newPosition
    });
  };
  const panelInlineStyles = {
    ...position,
    ...style,
    width: isMobile ? 'calc(100% - 2rem)' : style?.width || '360px'
  };
  useEffect(() => {
    if (isVisible) {
      document.addEventListener('click', handleDocumentClick, {
        capture: true
      });
      document.addEventListener('wheel', handleMouseScrollEvent);
    }
    return () => {
      document.removeEventListener('click', handleDocumentClick, {
        capture: true
      });
      document.removeEventListener('wheel', handleMouseScrollEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, ref]);
  const hideActionListPanel = event => {
    const floatingPanel = ref.current;
    const target = event.target;
    const targetId = target.getAttribute('id');
    if (floatingPanel && (!floatingPanel.contains(target) || target.classList.contains(floatingPanelStyles['sib-floating-panel-backdrop'])) && (!targetId || !targetId.includes('timepicker-action-id'))) {
      setIsVisible(false);
    }
  };
  const handleDocumentClick = event => {
    hideActionListPanel(event);
  };
  const onAnimationEnd = () => {
    if (ref.current && triggerRef.current) {
      handleTopBottomPosition(triggerRef.current, ref.current);
      setIsPanelReady(true);
    }
  };
  const handleMouseScrollEvent = e => {
    if (ref.current) {
      const panelRect = ref.current.getBoundingClientRect();
      const panelTop = panelRect.top + 16;
      if (!ref.current.contains(e.target) && e.clientY > panelTop) {
        setIsVisible(false);
      }
    }
  };
  return isVisible ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: backdropClasses,
    "data-test": "action-list-backdrop",
    "data-testid": "action-list-backdrop-id"
  }), /*#__PURE__*/React.createElement("div", {
    className: `${actionListBodyClasses} ${className}`,
    ref: ref,
    style: panelInlineStyles,
    onAnimationEnd: onAnimationEnd,
    id: "floating-panel-id",
    "data-testId": "floating-panel-id"
  }, /*#__PURE__*/React.createElement("div", {
    className: nestedClasses
  }, children))), document.body) : null;
});
FloatingPanel.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  setIsVisible: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  triggerRef: PropTypes.object.isRequired
};
export default /*#__PURE__*/React.memo(FloatingPanel);